export enum ENV {
  DEV = "dev",
  PROD = "prod",
  LOCAL = "local",
  TEST = "test",
}

export const MAX_PLAN_CONDITIONS = 6;

export enum LANGUAGES {
  EN = "en",
  AR = "ar",
}

export enum LOCAL_STORAGE_KEYS {
  THEME = "theme",
  LANGUAGE = "language",
  LOGIN_EMAIL = "login_email",
  SESSION_TOKEN = "session_token",
  REFRESH_TOKEN = "refresh_token",
  INTENDED_PATH = "intended_path",
}

export const PASSWORD_RULES = [
  {
    min: 8,
    message: "message.error.password_min_length",
  },
  {
    pattern: /.*[a-z].*/,
    message: "message.error.one_lowercase_required",
  },
  {
    pattern: /.*[A-Z].*/,
    message: "message.error.one_uppercase_required",
  },
  {
    pattern: /.*\d.*/,
    message: "message.error.one_digit_required",
  },
  {
    pattern: /.*[!@#+$%^&*(),.?":{}|<>].*/,
    message: "message.error.one_symbol_required",
  },
  {
    pattern: /^\S*$/,
    message: "message.error.no_spaces_allowed",
  },
];
